import { render, staticRenderFns } from "./CookieBox.vue?vue&type=template&id=360df5ae&scoped=true&"
import script from "./CookieBox.vue?vue&type=script&lang=js&"
export * from "./CookieBox.vue?vue&type=script&lang=js&"
import style0 from "./CookieBox.vue?vue&type=style&index=0&id=360df5ae&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "360df5ae",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('360df5ae')) {
      api.createRecord('360df5ae', component.options)
    } else {
      api.reload('360df5ae', component.options)
    }
    module.hot.accept("./CookieBox.vue?vue&type=template&id=360df5ae&scoped=true&", function () {
      api.rerender('360df5ae', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2dfpK4DzfU6f6/JS/comp/CookieBox.vue"
export default component.exports